import { useTranslation } from 'react-i18next';
import classes from './ServiceDetailsHeader.module.scss';

const ServiceDetailsHeader = () => {
  const { t: translate } = useTranslation();
  return (
    <div className={classes['service-details-header']}>
      <div className={classes['header-title']}>
        {translate('service_details_form_component.title_service_details')}
      </div>
      <div className={classes['header-subtitle']}>
        {translate('service_details_form_component.sub_title_service_details')}
      </div>
    </div>
  );
};
export default ServiceDetailsHeader;
